import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  HostBinding,
  Input,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * Custom Radio Component
 */
@Component({
  selector: 'atx-radio',
  templateUrl: './radio.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => RadioComponent),
    },
  ],
  // tslint:disable-next-line: prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class RadioComponent implements ControlValueAccessor {
  /**
   * Id for the input so the label can bind to the correct radio
   */
  @Input() public inputId: string;

  /**
   * The parent group name the element belongs to
   */
  @Input() public groupName: string;

  @HostBinding('class') public hostStyle = 'custom-control custom-radio';

  /**
   * Status of the shown element
   */
  @Input() public isDisabled = false;

  /**
   * Status of the shown element
   */
  @Input() public active: boolean;

  /** Dependencies */
  constructor(private cdr: ChangeDetectorRef) {}

  /**
   * Required for ControlValueAccessor implementation
   */
  public onChange: (checked: boolean) => void = () => {};

  /**
   * Required for ControlValueAccessor implementation
   */
  public writeValue(obj: boolean): void {
    this.active = obj;
  }

  /**
   * Required for ControlValueAccessor implementation
   */
  public registerOnChange(fn: () => {}): void {
    this.onChange = fn;
  }

  /**
   * Required for ControlValueAccessor implementation
   */
  public registerOnTouched(): void {}

  /**
   * Triggers onChange function if the input value is changed
   */
  public change($event: Event) {
    if ($event) {
      this.onChange(($event.currentTarget as HTMLInputElement).checked);
    }
  }

  /**
   * set disabled state if the input status is changed
   */
  public setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    this.cdr.detectChanges();
  }
}
